export default __webpack_public_path__ + "media/images/next-9dd14d400d4ebb65c66a7e1272a0c738.png";